import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints, colors }: ITheme) => ({
    buttonContainer: {
      width: 40,
      height: 40,
      display: 'flex',
      justifyContent: 'center',
      marginLeft: 'auto',
    },
    button: {
      borderColor: 'transparent',
      padding: [8, 9],
      marginLeft: 'auto',
      fill: colors.black,
      cursor: 'pointer',
      background: 'transparent',
      '& > span': {
        gap: 4,
      },
      '&:hover': {
        background: 'var(--x-bg-5)',
        borderRadius: '24px',
        fill: colors.black,
      },

      [mediaQuery(breakpoints.mobile)]: {
        padding: [6, 12],
      },
    },
    svgIcon: {
      width: 20,
      height: 20,
      fill: colors.black,
    },
  }),
  {
    name: 'widget-button',
  },
);

export default useStyles;
